import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import numeral from 'numeral'

export default class Variation extends React.Component {
  static propTypes = {
    amount: PropTypes.number
  }
  render() {
    const { amount } = this.props
    return (
      <div
        className={`${styles.container} col-xs-2`}
        style={{
          color: `${amount < 0 ? '#F5365E' : '#2ECE8A'}`,
          fontWeight: 'bolder'
        }}
      >
        {numeral(amount).format('0.00%')}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Mobile/Variation/index.js